// extracted by mini-css-extract-plugin
module.exports = {"productos":"Productos_productos__3P335","textContainer":"Productos_textContainer__1kHdd"};